var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditPenIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 4910"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 81",
    cx: 11.002,
    cy: 11.002,
    r: 11.002,
    fill: "#1D5D9B",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.72264 13.376C6.61775 13.376 6.51306 13.336 6.43295 13.2559C6.27294 13.0959 6.27294 12.8365 6.43295 12.6765L12.8361 6.27341C12.9959 6.1134 13.2555 6.1134 13.4155 6.27341C13.5755 6.43342 13.5755 6.69279 13.4155 6.85279L7.01233 13.2559C6.93243 13.3358 6.82754 13.376 6.72264 13.376Z",
    fill: "#1D4469"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.08999 16.3267C6.06151 16.3267 6.03262 16.3237 6.00374 16.3175C5.78247 16.27 5.64152 16.0522 5.68905 15.8309L6.32211 12.8802C6.36964 12.6589 6.58845 12.5184 6.80869 12.5655C7.02995 12.613 7.17091 12.8308 7.12338 13.052L6.49031 16.0028C6.44913 16.1952 6.27909 16.3267 6.08999 16.3267Z",
    fill: "#1D4469"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.04038 15.6937C8.93549 15.6937 8.8308 15.6537 8.75069 15.5736C8.59069 15.4136 8.59069 15.1542 8.75069 14.9942L15.1538 8.59134C15.3136 8.43134 15.5732 8.43134 15.7332 8.59134C15.8932 8.75135 15.8932 9.01072 15.7332 9.17073L9.33028 15.5736C9.25018 15.6537 9.14528 15.6937 9.04038 15.6937Z",
    fill: "#1D4469"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.08917 16.3267C5.90007 16.3267 5.73023 16.1952 5.68885 16.0028C5.64152 15.7816 5.78227 15.5638 6.00353 15.5163L8.95434 14.8832C9.17581 14.8363 9.39359 14.9768 9.44091 15.1979C9.48824 15.4192 9.34749 15.6369 9.12623 15.6845L6.17542 16.3175C6.14653 16.3239 6.11765 16.3267 6.08917 16.3267Z",
    fill: "#1D4469"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2846 10.4495C14.1797 10.4495 14.0748 10.4096 13.9949 10.3295L11.6771 8.01176C11.5171 7.85175 11.5171 7.59238 11.6771 7.43238C11.8369 7.27237 12.0967 7.27237 12.2565 7.43238L14.5742 9.75011C14.7343 9.91011 14.7343 10.1695 14.5742 10.3295C14.4943 10.4096 14.3894 10.4495 14.2846 10.4495Z",
    fill: "#1D4469"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4435 9.29078C15.3386 9.29078 15.2337 9.25083 15.1536 9.17073C14.9936 9.01072 14.9936 8.75135 15.1536 8.59114C15.3817 8.36312 15.5072 8.05437 15.5072 7.72207C15.5072 7.38976 15.3817 7.08102 15.1536 6.853C14.9254 6.62477 14.6167 6.49918 14.2843 6.49918C13.952 6.49918 13.6433 6.62477 13.4153 6.853C13.2555 7.013 12.9961 7.01321 12.8357 6.853C12.6757 6.69299 12.6757 6.43362 12.8357 6.27341C13.2184 5.8905 13.7328 5.67969 14.2843 5.67969C14.8357 5.67969 15.3503 5.8905 15.733 6.27341C16.1159 6.65611 16.3267 7.17055 16.3267 7.72207C16.3267 8.27359 16.1159 8.78802 15.733 9.17073C15.6533 9.25063 15.5484 9.29078 15.4435 9.29078Z",
    fill: "#1D4469"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPenIcon);
export default __webpack_public_path__ + "static/media/EditPenIcon.73a4c52d4b3b036cd4b8b7c3af412ea9.svg";
export { ForwardRef as ReactComponent };